<template>
  <v-app v-if="isLapTopCheck">
    <v-content>
      <section>
        <v-img
          :src="require('@/assets/backGround.jpg')"
          height="100%"
          >
          <v-container fluid fill-height>
            <v-layout justify-center column fill-height>
              <section v-if="alert">
                <v-container grid-list-md>
                  <v-layout align-center justify-center row>
                    <v-flex xs12>
                      <v-alert
                        v-model="alert"
                        dismissible
                        :type="alertType"
                        transition="scale-transition"
                      >
                      {{this.alertValue}}
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </section>
              <v-flex xs3>
                <v-layout align-center justify-center>
                  <v-img
                    :src="require('@/assets/logo.png')"
                    :lazy-src="require('@/assets/logo.png')"
                    contain
                    height="150">
                  </v-img>
                </v-layout>
              </v-flex>
              <v-flex xs8>
                <v-layout align-center justify-center>
                  <v-flex xs12 sm8 md4>
                    <v-card class="elevation-15">
                      <v-toolbar dark color="primary">
                        <v-toolbar-title>Log In</v-toolbar-title>
                        <v-spacer></v-spacer>
                      </v-toolbar>
                      <v-card-text>
                        <v-form>
                          <v-text-field v-model="email" prepend-icon="person" name="login" label="ไอดีเพื่อเข้าสู่ระบบ" type="text"></v-text-field>
                          <v-text-field v-model="password" id="password" prepend-icon="lock" name="password" label="รหัสเพื่อเข้าสู่ระบบ" type="password"></v-text-field>
                        </v-form>
                      </v-card-text>
                      <v-card-actions>
                        <v-layout align-center justify-center>
                          <v-btn v-on:click="logIn" color="primary">เข้าสู่ระบบ</v-btn>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-flex>

            </v-layout>

          </v-container>

        </v-img>
      </section>
    </v-content>
  </v-app>

  <!-- mobile version -->
  <v-app v-else>
    <log-in-mobile></log-in-mobile>
  </v-app>
</template>

<script>
import firebase from 'firebase'
import LogInMobile from './mobile/logInMobile.vue'

export default {
  components: {
    LogInMobile
  },
  props: ['isLapTopCheck'],
  data () {
    return {
      email: '',
      password: '',
      alert: false,
      alertType: 'error',
      alertValue: ''
    }
  },
  methods: {
    logIn: function () {
      const self = this
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(function () {
        self.$router.push('/list-product')
      }).catch(function (error) {
        console.log(error)
        self.alertValue = error.message
        self.alertType = 'error'
        self.alert = true
      })
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/logIn.vue